import { Component } from '@angular/core';
import { ModalService } from '@app/core/services/modal.service';
import { BusinessTransactionDto, BusinessTransactionService } from '@app/api/dmc';
import { HeaderService } from '@app/core/services/header.service';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  meteringPointBusinesstransactionTable
} from '@shared/table-configs/meteringpoint/meteringpoint-businesstransaction.table';
import { TableComponent } from '@shared/components/table/table.component';
import { ToggleComponent } from '@shared/components/input/toggle/toggle.component';
import {
  meteringpointTransactionsActionMenu
} from '@views/meteringpoint/meteringpoint-transactions/meteringpoint-transactions.action-menu';
import {
  ShowBusinesstransactionModalComponent
} from '@shared/modals/meteringpoint/businesstransactions/show-businesstransaction-modal/show-businesstransaction-modal.component';
import { MenuAction } from '@shared/interfaces/header/menu-action';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-meteringpoint-transactions',
  imports: [
    TableComponent,
    ToggleComponent,
    TranslatePipe,
    ReactiveFormsModule,
  ],
  templateUrl: './meteringpoint-transactions.component.html',
  styleUrl: './meteringpoint-transactions.component.css'
})
export class MeteringpointTransactionsComponent {
  public form: FormGroup = new FormGroup({
    showTidsserier: new FormControl(false)
  });

  /** Actions **/
  public actions: MenuAction[] = [
    {
      ...meteringpointTransactionsActionMenu[0],
      callback: () => this.openShowModal(),
      disabled: () => this.selectedElements.length !== 1
    }
  ]

  /** SelectedElements **/
  public selectedElements: BusinessTransactionDto[] = [];

  /** Table Config **/
  public transactionTableConfig = {
    ...meteringPointBusinesstransactionTable,
    contextActions: [
      this.actions[0]
    ],
    refreshable: true,
    refresh: () => this.fetchTransactions(),
  };

  /** Table Data **/
  public transactionTableData: BusinessTransactionDto[] = [];

  /** ID **/
  public id?: string;

  constructor(
    private readonly modalService: ModalService,
    private readonly businessTransactionService: BusinessTransactionService,
    private readonly headerMenuService: HeaderService,
    private readonly route: ActivatedRoute,
  ) {
    this.route.parent?.paramMap.subscribe((q: ParamMap) => {
      this.id = q.get('id')!;
      this.fetchTransactions();
    });

    this.headerMenuService.setActions(this.actions);

    this.form.get('showTidsserier')?.valueChanges.subscribe(() => {
      this.fetchTransactions();
    });
  }


  public openShowModal(): void {
    this.modalService.show({
        component: ShowBusinesstransactionModalComponent,
        title: 'meteringpoint.businesstransaction.show.title',
        size: 'md',
        actions: [
          { type: 'secondary', label: 'system.button.close', closeOnClick: true },
        ],
        params: {
          id: this.selectedElements[0].id,
          type: 'meteringpoint'
        }
      }
    )

  }

  private fetchTransactions(): void {
    if (!this.id) {
      return;
    }

    this.businessTransactionService.businessTransactionGetBusinessTransactionsMeteringPointGet(
      this.id,
      this.form.get('showTidsserier')?.value ?? false
    ).subscribe((data: BusinessTransactionDto[]) => {
      this.transactionTableData = data;
    });
  }
}
